import TokensService from '@omni/kit/services/TokensService';

import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupEvent } from '../Types';

const RESOURCE = 'events';

interface IGetGroupEventList extends Omit<IUri, 'resource'> {
  token?: string | null;
  appKey: string;
  endUserId: string;
  calendarId: string;
}
interface IGetGroupEventListResponse extends IHttpResponse {
  body?: {
    _embedded?: {
      events?: IGroupEvent[] | undefined;
    };
    count?: number;
  };
}
export default async ({
  token,
  appKey,
  endUserId,
  calendarId,
}: IGetGroupEventList): Promise<IGetGroupEventListResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    filters: [
      ['app_key', appKey],
      ['calendar.id', calendarId],
      ['status', 'published'],
    ],
    resource: RESOURCE,
  });
  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    token: token ? token : guestToken,
    skipTimestamp: true,
  });
};
